import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-chevron-up',
  templateUrl: './icon-chevron-up.component.html',
  styleUrls: ['./icon-chevron-up.component.scss']
})
export class IconChevronUpComponent {
  @Input() color = '--primary-text';
}
